export default __webpack_public_path__ + "static/img-point-second-4786bbef1d56c2f9c4feeedd464620ea.avif";